import { render } from "./WorkspaceMenu.vue?vue&type=template&id=6fb66eb2"
import script from "./WorkspaceMenu.vue?vue&type=script&lang=js"
export * from "./WorkspaceMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__